module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-also-by element-with-heading full-character-formatting",
    attrs: {
      "id": "also-by"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title case-upper"
  }, [_vm._v("ALSO BY TRICIA LEEDOM")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "also-by-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width also-by-content"
  }, [_vm._v("The Key West Escape Series")]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://www.fireflyhillpress.com/rum-runner",
      "target": "_blank"
    }
  }, [_vm._v("Rum Runner - Book 1")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://www.fireflyhillpress.com/bahama-mama",
      "target": "_blank"
    }
  }, [_vm._v("Bahama Mama - Book 2")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://www.fireflyhillpress.com/passion-punch",
      "target": "_blank"
    }
  }, [_vm._v("Passion Punch - Book 3")])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width also-by-content"
  }, [_vm._v("The Lost Souls’ Treasure Series")]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://www.fireflyhillpress.com/pieces-of-eight",
      "target": "_blank"
    }
  }, [_vm._v("Pieces of Eight - Book 1")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq also-by-content"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://www.fireflyhillpress.com/gentleman-of-fortune",
      "target": "_blank"
    }
  }, [_vm._v("Gentleman of Fortune - Book 2")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73384eb6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/alsobytricialeedom.vue
// module id = 66
// module chunks = 0